import { guideSteps } from "@/mocks/jiukanliao";

export default function GuideSection() {
  return (
    <section id="guide" className="bg-[#f6ecd8] py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-8">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-[#eccf9d] bg-[#fff6e6] px-3 py-1 text-xs font-semibold tracking-[0.15em] text-[#a86a1f]">
            <i className="ri-gps-line" />
            看图指南
          </span>
          <h2 className="font-display mt-4 text-3xl font-black text-[#231f18] md:text-4xl">
            三步看懂九宫格图集
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-7 text-[#8a7a5d]">
            初次接触九图吃瓜也不用慌，记住这三步，多图预警也能看得明明白白。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
          {guideSteps.map((s, i) => (
            <div
              key={s.num}
              className="relative overflow-hidden rounded-2xl border border-[#e5d5b0] bg-white/60 p-6"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#d9431f] text-sm font-bold text-white">
                {s.num}
              </span>
              <h3 className="font-display mt-4 text-lg font-bold text-[#231f18]">{s.title}</h3>
              <p className="mt-2 text-[13px] leading-6 text-[#6b5f48]">{s.desc}</p>
              {i < guideSteps.length - 1 && (
                <i className="ri-arrow-right-line absolute -right-2 top-1/2 hidden -translate-y-1/2 text-2xl text-[#d9b67a] md:block" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}